module.exports = __webpack_public_path__ + "fontawesome-webfont-v=4.4.0.4b5a84aaf1c9485e060c.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/font-awesome/fontawesome-webfont-v=4.4.0.woff2
// module id = 702
// module chunks = 2